<template>
  <div id="software">
    <my-header activeIndex="北航软件学院案例" />
    <div class="banner"></div>
    <div class="wrapper">
      <div class="title">
        全国 <span>首个</span> 软件工程领域人工智能硕士研究方向
      </div>
      <div class="content clearfix">
        <ul class="tabBar">
          <li
            v-for="(item, index) in list"
            :key="index"
            :class="{ active: listIndex === index }"
            @click="listIndex = index"
          >
            <span v-html="item"></span>
          </li>
        </ul>
        <div class="tabList">
          <div class="box clearfix">
            <transition name="fade">
              <div v-show="listIndex === 0">
                <p style="padding-bottom:35px;">
                  为了贯彻落实《国家产教融合建设试点实施方案》（以下简称《实施方案》），深化产教融合，促进教育链、人才链与产业链、创新链有机衔接，推动教育优先发展、人才引领发展、产业创新发展、经济高质量发展相互贯通、相互协同、相互促进的战略性举措，北京航空航天大学联合创客天下（北京）科技发展有限公司（以下简称：创客天下）以及其运营的中关村人工智能创新创业基地，依托基地优质的人工智能产业资源，进行软件工程领域的人工智能研究方向围绕工程实践、实习实训等方面开展校企联合人才培养，以培养“工程实践+创新能力”的复合型专业人才为目标，为区域创新驱动及产业发展提供人才支撑。
                </p>
                <p>
                  中关村人工智能创新创业基地是在北京市经济和信息化局、海淀区人民政府的指导和支持下以“助力北京建设科技创新中心，促进人工智能与实体经济相结合，打造人工智能产业生态集群”为主旨，打造的线上线下一体化创新服务平台，围绕人工智能产业发展急需的人才资源、产业创新资源和企业专业服务资源三方面开展相关工作。已经与中科院计算机网络信息中心、微软互联网工程院、京东、新智元、易华录等业内优质资源开展合作，在人工智能计算资源、数据资源、人才培养、算法设计和数据应用等领域共建创新服务平台和开放实验室。通过平台型的产业创新生态的搭建，构建创新创业资源汇聚平台，聚集人才、创新创业团队创业投资等多方资源，带动地区科技创新，经济发展与产业升级，助力北京建设科技创新中心。
                </p>
                <div class="twoillustration " style="padding:47px 0 135px;">
                  <div style=" margin: 0 35px;">
                    <img src="../../assets/images/softwarebg1.jpg" />
                    <span>图-中关村人工智能创新创业基地</span>
                  </div>
                  <div style=" margin: 0 35px;">
                    <img src="../../assets/images/softwarebg2.jpg" />
                    <span>图-北京航空航天大学</span>
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div v-show="listIndex === 1">
                <p style="padding-bottom:35px;">
                  深度参与北航软件学院人工智能研究方向的学生工程实践内容，工程实践包括：一级工程实践、二级工程实践，总计学时：64学时，共4学分。目前累计参与工程实践课程学习和实践的学生人数382人。
                </p>
                <h3>一级工程实践</h3>
                <p style="padding-bottom:35px;">
                  一级工程实践是将程序设计语言、数据结构、操作系统、网络编程融合在一起的综合实践系列课程，采用课堂教学与实践相结合的方式，训练学生的综合编程基础技能，通过实验、作业、讨论、笔试等多种形式来保障教学质量，为后续专业课程学习奠定基础。
                </p>
                <h3>二级工程实践</h3>
                <p style="padding-bottom:35px;">
                  二级工程实践中，学生自由组成4-6人的开发小组（开发团队），遵循软件开发过程管理规范，以团队形式开发完成具有一定规模的应用性项目，培养学生规范化软件开发和管理的能力。通过立项、分析设计与开发、现场答辩、演示等形式跟踪教学质量。为了更好的保障学生工程实践学习效果和项目实践体验，运用了自主研发的Noosphere汽车自动驾驶教学科研平台。
                </p>
                <h3>工程实践课程名称及学时</h3>
                <p style="padding-bottom:35px;">
                  以下为软件学院人工智能方向的学生开设的一级和二级工程实践课程内容，其中大部分的实践课程都基于Noosphere汽车自动驾驶教学科研平台实现，更好的服务教学和学生实践工作。
                </p>
                <div class="illustration" style="padding: 0 0 80px;">
                  <img src="../../assets/images/softwaretable.png" />
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div v-show="listIndex === 2">
                <p>
                  依托中关村人工智能创新创业基地优质的人工智能产业生态圈，搭建中关村人工智能创新服务平台，能为学生提供人工智能及自动驾驶细分领域等的相关课程资源、数据资源和超级计算力平台资源。平台以人才培养为切入点，通过人才关键要素贯穿产业与创新发展，形成产业与人才、产业与技术、产业与创新融合的发展格局，为高校打造更加落地的产教融合模式和创新人才培养模式。
                </p>
                <p>
                  平台定期进行升级和维护，在读学生可以通过平台注册并登录，获取学习资源和项目案例资源。
                </p>
                <div class="illustration" style="padding: 50px 0 100px;">
                  <img src="../../assets/images/softwareterrace.png" />
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div v-show="listIndex === 3">
                <h1 style="padding-bottom:15px;">企业Open Day</h1>
                <p>
                  每年至少组织2次北航软件学院方向的学生参加企业参观交流活动，目前已经参观交流的企业有微软、百度、商汤等。
                </p>
                <div class="twoillustration " style="padding:40px 0 45px;">
                  <div style=" margin: 0 25px;">
                    <img
                      src="../../assets/images/software1.jpg"
                      width="369"
                      height="220"
                    />
                    <span>图-北航软件学院 微软加速器 AI人才交流大会</span>
                  </div>
                  <div style=" margin: 0 25px;">
                    <img
                      src="../../assets/images/software2.jpg"
                      width="369"
                      height="220"
                    />
                    <span>图-百度AI人才交流会</span>
                  </div>
                </div>
                <h1 style="padding-bottom:15px;">校企联合实验室</h1>
                <p style="padding-bottom:20px;">
                  为了贯彻国家发展战略，助力中国人工智能行业的发展，创客天下集聚高校和企业资源，联合领域知名高校和行业领军企业，共建AI联合实验室，加强高校与企业在专业实践、技术开发、人才培养等方面的深度合作，促进校企产学研的政策落地。
                </p>
                <p>
                  中关村人工智能创新创业基地依托北京航空航天大学、中科院自动化研究所等业内一流高校和科研院所，并联合百度、创新工场、京东等知名AI企业，共同打造校企联合实验室促进人才培养、项目实践和创新应用。建立自动驾驶实验室、智能推荐系统联合实验室、自主可控智能芯片与物联网创新应用中心等多个联合实验室，并与中科院计算机网络信息中心、中科院自动化研究所国家模式识别重点实验室建立校外联合人才培养的模式，累计推荐进入实验室及实习的学生人数近80人。
                </p>
                <div class="twoillustration " style="padding:55px 0 50px;">
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software3.jpg" />
                  </div>
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software4.jpg" />
                  </div>
                </div>
                <div class="twoillustration " style="padding:0 0 55px;">
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software5.jpg" />
                  </div>
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software6.jpg" />
                  </div>
                </div>
                <h1 style="padding-bottom:15px;">高端大讲堂</h1>
                <p>
                  通过我们提供的主题技术交流、大咖分享及专题论坛等活动，丰富学生的高端大讲堂课程内容和形式，帮助学生了解最新技术、前沿行业应用案例和发展趋势。已经开展高端大讲堂包括：无人系统专题技术分享、李开复博士走进北航公开课、智能驾驶高峰论坛等。
                </p>
                <div class="twoillustration " style="padding:60px 0 95px;">
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software8.jpg" />
                    <span>图-李开复《AI.未来》公开课</span>
                  </div>
                  <div style=" margin: 0 25px;">
                    <img src="../../assets/images/software7.jpg" />
                    <span>图-李开复《AI.未来》公开课现场</span>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <my-footer />
  </div>
</template>
<script>
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";
export default {
  name: "software",
  data() {
    return {
      list: [
        "合作背景",
        "联合人才培养",
        "人工智能产教融<br/>合创新服务平台",
        "深度产教融合"
      ],
      listIndex: 0
    };
  },
  components: { MyHeader, MyFooter }
};
</script>
<style lang="less">
#software {
  color: #333333;
  background: #f8fbff;
  .banner {
    width: 100%;
    padding-top: 23.4%;
    background: url("../../assets/images/cooperationcase.jpg");
    background-size: 100% 100%;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .title {
    padding: 88px 0 81px 200px;
    font-size: 22px;
    line-height: 30px;
    text-align: center;
    letter-spacing: 3px;
    font-weight: bold;
    span {
      font-size: 30px;
      color: #0d66ee;
    }
  }
  .content {
    font-size: 16px;
    text-align: justify;
    letter-spacing: 2px;
    .tabBar {
      float: left;
      width: 140px;
      padding-right: 40px;
      li {
        background: #ffffff;
        cursor: pointer;
        &.active {
          color: #ffffff;
          background: #0d66ee;
        }
        span {
          display: table-cell;
          vertical-align: middle;
          width: 140px;
          height: 66px;
          text-align: center;
        }
      }
    }
    .tabList {
      float: left;
      width: 1000px;
      padding-left: 20px;
      overflow: hidden;
      .box {
        width: 4000px;
        > div {
          float: left;
          width: 1000px;
          h1 {
            font-size: 20px;
            line-height: 20px;
            font-weight: bold;
          }
          h2 {
            line-height: 36px;
            color: #0d66ee;
          }
          h3 {
            position: relative;
            line-height: 36px;
            font-size: 16px;
            font-weight: bold;
            &::before {
              content: "";
              position: absolute;
              top: 13px;
              left: -20px;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #0d66ee;
            }
          }
          p {
            line-height: 36px;
            span {
              color: #0d66ee;
            }
          }
          .illustration {
            text-align: center;
            span {
              display: block;
              padding-top: 30px;
            }
          }
          .twoillustration {
            text-align: center;
            > div {
              display: inline-block;
              img {
                display: block;
              }
            }
            span {
              display: block;
              padding-top: 30px;
              font-size: 14px;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
}
</style>
